import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { SUPPORTED_PROPERTIES } from '@savgroup-front-common/types';

import { getCustomComponentProperty } from '../../helpers';

interface LogoContainerProps {
  componentThemeName: string;
  $isMobileView?: boolean;
}

export const $LogoContainer = styled('div')<LogoContainerProps>`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 260px;
  height: ${spacing(11)};
  cursor: pointer;

  padding: 0;

  position: relative;
  text-align: ${({ componentThemeName, theme, $isMobileView }) => {
    if ($isMobileView) {
      return 'left';
    }

    return getCustomComponentProperty({
      theme,
      componentName: componentThemeName,
      property: SUPPORTED_PROPERTIES.TEXT_ALIGN,
      fallback: 'left',
    });
  }};
`;
